<template lang="pug">
div
  v-toolbar(color="primary", dense, dark)
    .header(align="center")
      v-toolbar-title
        div(
          style="color: orange; text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black",
          align="center"
        ) ezServ-R
  v-label
    .pt-2(align="center")
      strong Dear {{  selectedUser?selectedUser.fullName:&apos;Customer&apos;  }},
    .pt-2(align="center")
      | Welcome to
      strong ezServ-R
    .pt-2.pb-2(align="center") A Service Management Product for Restaurants
    .pt-2.pb-2(align="center")
      strong.pb-5 Please watch this video to Get Started:
      .pt-6
      v-btn(large, tile, @click="alert('Coming Soon')") 
        v-icon(color="red") mdi-youtube
        span Watch Video
    //- .text-center.pb-0.pt-5
    //-   v-sheet.mx-auto(elevation="6", height="180", width="320")
    //-     img(src="/images/comingsoon.png")
  v-row.pa-2.pt-0
    v-col
      v-alert(
        v-model="showAlert",
        dense,
        dismissible,
        type="info",
        @input="refresh()"
      ) {{ alertMessage }}
  v-divider
  v-row.pa-2(wrap)
    v-col
      v-label
        // <div align="center" class="pt-2">Click a button below to Sign-in:</div>
  v-row.pa-2(wrap)
    v-col
      #firebaseui-auth-container
</template>
<script>
import { storeMixin } from "../mixins/storeMixin.js";
import { scaffolderMixin } from "../mixins/scaffolderMixin.js";
import firebase from "firebase";
import * as firebaseui from "firebaseui";

export default {
  name: "login",
  mixins: [storeMixin, scaffolderMixin],
  mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      user ? this.login(user) : this.startLoginUI();
    });
  },
  data() {
    return {
      alertMessage: "",
      showAlert: false,
      defaultItem: {
        name: "My Group of Restaurants",
        code: "G001",
        pricingPlan: "Nucleus",
        features: "",
        adminFullName: "Group Admin",
        productTags:
          "Veg,Non-Veg,North Indian,South Indian, Chinese,Starters,Chicken,Sea Food",
        customTags: "Spicy,No Sugar,1by2,2by3,gravy,dry",
        status: 1, //status New
        adminMobile: "9999999999",
        notes: "newly created",
      },
      editedItem: {},
    };
  },
  methods: {
    init() {
      Object.assign(this.editedItem, this.defaultItem);
    },
    refresh() {
      location.reload();
    },
    async startLoginUI() {
      const uiConfig = {
        callbacks: {
          signInFlow: "redirect",
          signInSuccessWithAuthResult: (authResult) => {
            // 2nd param redirectUrl not used
            if (authResult.user) {
              this.login(authResult.user);
              //handleSignedInUser(authResult.user);
              //this.$router.push("/success");
              return;
            }
          },
        },
        signInOptions: [
          {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            // Required to enable this provider in One-Tap Sign-up.
            authMethod: "https://accounts.google.com",
            // Required to enable ID token credentials for this provider.
            clientId:
              "738380839551-s6923vskdgpl0vdsld9frlge06e8hdlm.apps.googleusercontent.com",
            customParameters: {
              // Forces account selection even when one account
              // is available.
              prompt: "select_account",
            },
          },
          {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            // Whether the display name should be displayed in Sign Up page.
            requireDisplayName: true,
            signInMethod: "getEmailSignInMethod()",
          },
          {
            provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
            defaultCountry: process.env.VUE_APP_COUNTRY || "IN",
            // whitelistedCountries: ["IN", "CA", "US", "GB"],
            whitelistedCountries: [process.env.VUE_APP_COUNTRY || "IN"],
            recaptchaParameters: {
              size: "getRecaptchaMode()",
            },
          },
        ],
        // Required to enable one-tap sign-up credential helper.
        credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
      };
      const ui =
        firebaseui.auth.AuthUI.getInstance() ||
        new firebaseui.auth.AuthUI(firebase.auth());
      ui.disableAutoSignIn();
      ui.start("#firebaseui-auth-container", uiConfig);
    },
    async login(user) {
      let userObj = {
        uid: user.uid,
        code: "U001",
        fullName: user.displayName,
        imageUrl: user.photoURL,
        email: user.email,
        emailVerified: user.emailVerified,
        mobileNumber: user.phoneNumber,
        role: "",
        roles: [],
        notes:
          "Thank you for the Sign-uo. Your request has been registered and the account will be activated by the admin in a while. Please try after some time. We appreciate your patience.",
        status: 0, //Keep status disabled
      };
      const dbUser = await this.lookupUser(userObj);
      if (!dbUser || dbUser.status == 0) {
        this.alertMessage = ` 
          ${dbUser ? "Message from EzServ Team: " + dbUser.notes : ""}`;
        this.showAlert = true;
        firebase
          .auth()
          .signOut()
          .then(() => {
            //location.reload();
          });
      } else {
        this.selectUser(dbUser);
        if (this.selectedUser._groupKey) {
          const dbGroup = await this.readDocByIdSync({
            collectionName: "groups",
            docId: this.selectedUser._groupKey,
            predicates: [{ key: "status", op: "==", val: 1 }],
          });
          this.selectGroup(dbGroup);
          this.$router.replace("/home");
        } else {
          this.createDefaultGroup();
        }
      }
    },
    async lookupUser(user) {
      let dbUser = null;
      let predicates = []; //{ key: "status", op: "==", val: 1 }];
      if (user.email) {
        predicates.push({ key: "email", op: "==", val: user.email });
      } else if (user.mobileNumber) {
        predicates.push({
          key: "mobileNumber",
          op: "==",
          val: user.mobileNumber,
        });
      }
      let dbUsers = await this.loadDocs({
        collectionName: "users",
        predicates: predicates,
      });
      if (dbUsers.length == 0) {
        const payLoad = { collectionName: "users", doc: user };
        await this.createDocSync(payLoad);
        dbUsers = await this.loadDocs({
          collectionName: "users",
          predicates: predicates,
        });
      }
      if (dbUsers.length != 0) {
        dbUser = dbUsers[0];
      }
      return dbUser;
    },
  },
};
</script>
<style scoped>
.header {
  float: right;
  width: 100%;
}
</style>